<template>
  <div class="expand-box">
    <div class="expand-row">
      <div class="expand-col">
        <span class="expand-key">
          {{ $t("arrival_HK") }} - {{ $t("dept_HK") }}
        </span>
        <span class="expand-value">{{ row.residence_time }}</span>
      </div>
      <div class="expand-col">
        <span class="expand-key">
          {{ $t("dept_HK") }} - {{ $t("arrive") }}
        </span>
        <span class="expand-value">{{ row.flight_time }}</span>
      </div>
      <div class="expand-col">
        <span class="expand-key">
          {{ $t("arrive") }} - {{ $t("clearance") }}
        </span>
        <span class="expand-value">{{ row.clearance_time }}</span>
      </div>
      <div class="expand-col">
        <span class="expand-key">
          {{ $t("clearance") }} - {{ $t("to_station") }}
        </span>
        <span class="expand-value">{{ row.arrival_time }}</span>
      </div>
    </div>
    <div class="expand-row">
      <div class="expand-col">
        <span class="expand-key">{{ $t("orderNums") }} </span>
        <span class="expand-value">{{ row.order_total }}</span>
      </div>

      <div class="expand-col">
        <span class="expand-key">{{ $t("not_arrival_warehouse") }} </span>
        <template v-if="row.not_arrival_warehouse > 0">
          <Button
            type="error"
            class="expand-value"
            @click="clickNum('not_arrival_warehouse', row.extract_id)"
            >{{ row.not_arrival_warehouse }}</Button
          >
        </template>
        <template v-else>
          <span class="expand-value">{{ row.not_arrival_warehouse }}</span>
        </template>
      </div>

      <div class="expand-col">
        <span class="expand-key">{{ $t("pod_num") }}</span>
        <span class="expand-value">{{ row.pod }}</span>
      </div>

      <div class="expand-col">
        <span class="expand-key">{{ $t("pod_rate") }}</span>
        <span class="expand-value">{{ row.pod_rate }}</span>
      </div>
    </div>
    <!-- <div class="expand-row">
      <div class="expand-col">
        <span class="expand-key">{{ $t("refusal_number") }} </span>
        <span class="expand-value">{{ row.refuse }}</span>
      </div>

      <div class="expand-col">
        <span class="expand-key">{{ $t("refusal_rate") }} </span>
        <span class="expand-value">{{ row.refuse_rate }}</span>
      </div>

      <div class="expand-col">
        <span class="expand-key">{{ $t("orderError") }} </span>
        <template v-if="row.exception_order > 0">
          <Button
            type="error"
            class="expand-value"
            @click="clickNum(2, row.extract_id)"
            >{{ row.exception_order }}</Button
          >
        </template>
        <template v-else>
          <span class="expand-value">{{ row.exception_order }}</span>
        </template>
      </div>
    </div>
    <div class="expand-row">
      <div class="expand-col">
        <span class="expand-key">NCND: </span>
        <span class="expand-value">{{ row.NCND }}</span>
      </div>

      <div class="expand-col">
        <span class="expand-key">{{ $t("three_pod_rate") }}</span>
        <span class="expand-value">{{ row.ncnd_three_pod_rate }}</span>
      </div>

      <div class="expand-col">
        <span class="expand-key">{{ $t("seven_pod_rate") }} </span>
        <span class="expand-value">{{ row.ncnd_seven_pod_rate }}</span>
      </div>

      <div class="expand-col">
        <span class="expand-key">{{ $t("ten_pod_rate") }} </span>
        <span class="expand-value">{{ row.ncnd_ten_pod_rate }}</span>
      </div>
    </div>
    <div class="expand-row">
      <div class="expand-col">
        <span class="expand-key">NOR: </span>
        <span class="expand-value">{{ row.NOR }}</span>
      </div>

      <div class="expand-col">
        <span class="expand-key">{{ $t("three_pod_rate") }}</span>
        <span class="expand-value">{{ row.nor_three_pod_rate }}</span>
      </div>

      <div class="expand-col">
        <span class="expand-key">{{ $t("seven_pod_rate") }} </span>
        <span class="expand-value">{{ row.nor_seven_pod_rate }}</span>
      </div>

      <div class="expand-col">
        <span class="expand-key">{{ $t("ten_pod_rate") }} </span>
        <span class="expand-value">{{ row.nor_ten_pod_rate }}</span>
      </div>
    </div> -->
    <Modal
      v-model="isShow"
      :loading="loading"
      :title="title"
      @on-ok="copy"
      :ok-text="$t('copy')"
      width="600"
    >
      <!-- <div slot="header">
        {{ title }}
        <Button
          style="margin-left:20px"
          type="primary"
          @click="copy"
          size="small"
        >
          {{ $t("copy") }}
        </Button>
      </div> -->
      <div class="cnb-div">
        <span class="cnb-num" v-for="item in list" :key="item">{{ item }}</span>
      </div>
      <Spin size="large" fix v-if="spinShow">
        <Button loading shape="circle" type="primary"></Button>
        <div>loading...</div>
      </Spin>
    </Modal>
  </div>
</template>
<script>
import { getExtractException, getExtractNotWarehouse } from "@/api/extract/new";
import copyClick from "@/utils/copyClick";

export default {
  props: {
    row: Object
  },
  data() {
    return {
      isShow: false,
      title: "",
      loading: false,
      list: [],
      spinShow: false
    };
  },
  methods: {
    clickNum(val, id) {
      this.title = this.$t(val);
      this.spinShow = true;
      if (val == 2) {
        this.title = this.$t("orderError");
        getExtractException(id).then(res => {
          this.spinShow = false;
          this.list = res.data.payload;
        });
      } else {
        getExtractNotWarehouse(id).then(res => {
          this.spinShow = false;
          this.list = res.data.payload;
        });
      }
      this.loading = true;
      this.isShow = true;
    },
    copy() {
      this.loading = false;
      let setT = setTimeout(() => {
        this.loading = true;
        clearTimeout(setT);
      }, 1);
      let data = this.list.join("\r\n");
      copyClick.copyToClipboard(data, this);
    }
  }
};
</script>
<style>
.expand-row {
  margin-bottom: 16px;
  display: flex;
  height: 40px;
  align-items: center;
}
.expand-row:last-child {
  margin-bottom: 0;
}
.expand-col {
  border: 1px solid #bbb;
  height: 100%;
  display: flex;
  align-items: center;
  border-left: none;
  background: #fff;
}
.expand-col:first-child {
  border: 1px solid #bbb;
}
.expand-key {
  width: 120px;
  border-right: 1px solid #bbb;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 10px;
}
.expand-value {
  width: 120px;
  padding: 0 10px;
  height: 100%;
  border-radius: 0;
  display: flex;
  align-items: center;
  font-weight: bold;
}
</style>
